// Notification center (inbox page) strings (auto-merged by lib/i18n.ts).
export const en = {
  'notif.center.view': 'View',
  'notif.center.download': 'Download',
  'notif.center.mark_read': 'Mark read',
  'notif.center.empty': 'No notifications yet.',
  'notif.center.unread_count': '{n} unread',
  'notif.center.all_caught': "You're all caught up.",
  'notif.ref.shipment': 'Shipment {ref}',
  'notif.ref.quote': 'Quote {ref}',
  'notif.ref.invoice': 'Invoice {ref}',
}

export const zhTW = {
  'notif.center.view': '檢視',
  'notif.center.download': '下載',
  'notif.center.mark_read': '標示為已讀',
  'notif.center.empty': '尚無通知。',
  'notif.center.unread_count': '{n} 則未讀',
  'notif.center.all_caught': '您已全部讀取完畢。',
  'notif.ref.shipment': '貨件 {ref}',
  'notif.ref.quote': '報價 {ref}',
  'notif.ref.invoice': '發票 {ref}',
}
